import React, { useState } from 'react';
import { useMedia } from 'react-use';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Switch, Typography, DataTable, LazyLoadImage } from 'ck-ui';
import { getSanityImg } from 'src/sanityClient';
import styles from './SizeChartContent.module.scss';

const SizeChartContent = ({ item }) => {
  const [unit, setUnit] = useState('inch');
  const isMobile = useMedia('(max-width: 767px)');
  const variant = isMobile ? 'heading6' : 'heading5';
  const bodyVariant = isMobile ? 'body' : 'body-xlarge';

  if (!item.table) return null;
  const columns = item.table.rows[0].cells.map((label) => ({ id: label, label }));
  const dataItems = item.table.rows.slice(1).map((ele, rowId) => {
    const result = {};
    ele.cells.forEach((v, index) => {
      result[columns[index].id] = v;
    });
    result.id = `${item.gender}-${item.category}-${rowId}`;
    return result;
  });
  const filterColumns = item.noSwitch
    ? columns
    : columns.filter((column) => {
      const columnId = column.id.toLowerCase();
      return columnId.includes(unit) || !(columnId.includes('cm') || columnId.includes('inch'));
    });
  return (
    <>
      <div className={styles.section}>
        <Typography variant={isMobile ? 'heading5' : 'heading4'} uppercase className={styles.title}>{item.title}</Typography>
        <Typography variant={bodyVariant}>Find your correct size in the chart below. Scroll horizontally to find more sizes.</Typography>
      </div>

      <div className={classnames(styles.toggle, styles.section)}>
        <Typography variant={variant} uppercase>SIZE CHART</Typography>
        {
          !item.noSwitch && (
            <Switch
              leftLabel="in."
              leftValue="inch"
              rightLabel="cm."
              rightValue="cm"
              onChange={(value) => {
                setUnit(value);
              }}
            />
          )
        }
      </div>

      <DataTable className={styles.table} columns={filterColumns} items={dataItems} headerBordered hasCellMinWidth centeredText />

      {(item.tips || item.image) && (
        <div className={styles.section}>
          <Typography variant={variant} className={styles.headerTip}>MEASUREMENT & SIZE TIPS</Typography>
          {item.tips && <Typography variant={bodyVariant}>{item.tips}</Typography> }
          {item.image && (
            <div className={styles.imgRoot}>
              <div className={styles.parent}>
                <div className={styles.wrapper}>
                  <LazyLoadImage
                    src={getSanityImg(item.image)
                      .width(1000)
                      .height(650)
                      .auto('format')
                      .url()}
                    alt={item.title}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

SizeChartContent.propTypes = {
  item: PropTypes.object.isRequired
};

export { SizeChartContent };
